module.exports = __webpack_public_path__ + "media/images/lb/308-7bd56e470b0ce5f8b64cb70c3f6973f0.svg";